module.exports = __webpack_public_path__ + "static/media/portfolio1 (14).a5532d4f.jpeg";